




































































































































































































































































































import XLSX from 'xlsx';
import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import { PageTitle } from '../../core/components';

@Component({
    components: {
        PageTitle
    }
})
export default class TermsAndConditions extends Mixins() {}
